import { store } from '@sonifi/wb-core/store/store';
import {
  clearRowsAndForm,
  initRowExpanded,
  loadProperties,
  loadProperty,
} from '../properties/services/properties.service';
import { buildApiParamsPagination } from '@sonifi/wb-widget/store/tableConfig/tableConfigInitialState';
import { TABLE_KEYS } from '@sonifi/wb-widget/store/tableConfig/tableConfigConstants';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';

function checkIfPropertiesAreLoaded(apiParams) {
  const state = store.getState();
  const {
    adminProperties: { loadingProperties, properties },
  } = state;
  const currentPagination =
    state.tableConfig.pagination[TABLE_KEYS.adminProperties];

  // If properties are loaded and params match, just update expanded state without refetching
  if (
    loadingProperties === LOADING_STATUS.success &&
    properties.length > 0 &&
    currentPagination &&
    currentPagination.page === apiParams.page &&
    currentPagination.pageSize === apiParams.pageSize &&
    currentPagination.query === apiParams.query &&
    currentPagination.sortBy === apiParams.sortBy &&
    currentPagination.sortDir === apiParams.sortDir
  ) {
    return true;
  }
  return false;
}

export async function loaderProperties({ request }) {
  const apiParams = buildApiParamsPagination(request);

  store.dispatch(clearRowsAndForm());

  if (checkIfPropertiesAreLoaded(apiParams)) {
    return {};
  }

  await store.dispatch(loadProperties(apiParams));
  return {};
}

export async function loaderPropertyById({ params, request }) {
  const { id } = params;
  const addProperty = id === 'add';
  const expandedRowId = addProperty ? null : parseInt(id);

  const apiParams = buildApiParamsPagination(request);
  if (!checkIfPropertiesAreLoaded(apiParams)) {
    await loaderProperties({ request });
  }

  store.dispatch(initRowExpanded(expandedRowId, addProperty));
  // Don't wait here because uses the internal loading in the WbTable
  store.dispatch(loadProperty({ id: expandedRowId, add: addProperty }));
  return {};
}
